require("!!/opt/app/node_modules/script-loader/addScript.js")(require("!!/opt/app/node_modules/raw-loader/index.js!/opt/app/static/chart/chart-bundle.min.js"))